import React from "react";
import styles from "../../styles/components/basicForm.module.scss";
import Icons from "../../public/assets/svg";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
//import Router from "next/router";
import DropDown from "../listWithoutcheck";
import _get from "lodash/get";
import _ from "lodash"
// import { useDispatch } from "react-redux";
// import { isNull } from "lodash";

function index(props) {
//console.log("basic form-----" , props)
let notRequired=['Area','Sub Area','MCO','Lead Platform']
  //const dispatch = useDispatch();

 // let initialStates = {};
  const [state, setState] = React.useState({});
  const [value, setValue] = React.useState("")

  // React.useEffect(() => {
  //   try {
  //     if (props.userType != undefined) {
  //       console.log("1")
  //       if (props.userType == "gCad") {
  //         console.log("1")
  //         setState({
  //           ...state,
  //           cluster: "Global",
  //           mco: "Global"
  //         });
  //       }

  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }, []);
 

  let inputprops = {
    placeholder: "DD-MM-YYYY",
    readOnly: true
  };

  function formatDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
  }

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  props.data.map((item) => {
    if (item.field_label == "Comments From Stakeholders") {
      item.value = "commentsFromStakeHolder";
    } else if (item.field_label == "EL") {
      item.value = "el";
    } else if (item.field_label == "MCO") {
      item.value = "mco";
    } else if (item.field_label == "SPOC") {
      item.value = "spoc";
    } else {
      item.value = camelize(item.field_label);
    }
  });

  let dropDownsInitialStates = {};
 const [ requiredFields, setRequiredFields ] = React.useState([])

  // nested dropdown
  props.data.map((item) => {
    if (
      item.field_input_type == "Related Dropdown" &&
      item.field_related_dropdown.length > 0
    ) {
      let fieldOptions = [];
      item.field_dropdown_option_component.map((item) => {
        fieldOptions = [...fieldOptions, ...item.field_options];
      });
    }
  });

  // intial states setup

  // states
  const [relatedDropdowns, setRelatedDropdowns] = React.useState(null);

  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );
  const [invalidFlag, setInvalidFlag] = React.useState(false);

  // related dropdowns initial setup

  let initialStates ={}
  React.useEffect(() => {
    
    
    let requiredFieldsAr = []
    props.data.map((item) => {
      if (item.field_input_type == "Date") {
       // initialStates[item.value] = formatDate();
      } else if (item.field_input_type == "Radio") {
        if (item.field_label == "Target Pitch") {
          initialStates[item.value] = item.field_options[0];
        }
      } else {
        initialStates[item.value] = "";
      }
  
      if (
        item.field_input_type == "Dropdown" ||
        item.field_input_type == "Related Dropdown"
      ) {
        dropDownsInitialStates[item.value] = false;
      }
      if (item.field_required == "1") {
        // if(!props.notRequired.includes(item.field_form_field_title))
        requiredFieldsAr.push(item.value);
      }
    });

   setRequiredFields([...requiredFieldsAr])


    let relatedDropdownToSet = {};
    props.data.map((item) => {
      if (item.field_input_type == "Related Dropdown") {
        relatedDropdownToSet[item.value] = item.field_dropdown_option_component;
      }
    });
    setRelatedDropdowns(relatedDropdownToSet);
    setDropdownState({...dropDownsInitialStates})

    if (props.formType == "demand" || props.formType == "getBot"|| props.formType == "userAccessEdit" || props.formType=="userCreateData" ||props.formType=="approval") {
      //
//console.log(props.demandEditData, "demandEditData")
      if (props.demandEditData != null) {
        if (props.demandEditData.cluster && props.formType == "userAccessEdit"){
         // console.log(relatedDropdownToSet, "relatedSsupYo", props.data)
           relatedDropdownToSet["mco"].nowValues = relatedDropdownToSet["mco"].filter((itemmco) => itemmco.field_title == props.demandEditData.cluster)[0].field_options
        }
        setState({...props.demandEditData});
      }
      else {
        setState({...initialStates})
      }
    }
  }, []);



  React.useEffect(() => {
    if  ( ! _.isEmpty(props.approvalEditData) ) [
      setState({...props.approvalEditData})
    ]
  }, [props.approvalEditData])


  // React.useEffect(() => {
  //   if (props.editData) {
  //     setState({...props.editData})
  //   }
  // }, [])




  React.useEffect(() => {
  
    if (props.reset) {
      //alert("hii")
      setDropdownState(dropDownsInitialStates)
      setState(initialStates);
      props.setreset(false);
      let reall =  relatedDropdowns
      for ( let i in reall) {
      delete reall[i]['nowValues']  
      }
      setRelatedDropdowns({...reall})
    
    }
  }, [props.reset]);

 


  // handling input values
  

  // text input changes
  const inputChange = (e) => {
    //console.log(e.target.name, "scsd", e.target.value, "allfsds", state);
    setState({ ...state, [e.target.name]: e.target.value });
  };

  // dropdown open close
  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
    //console.log(item,"itemsss");
    props.data.map((item)=>{
      //console.log(item,"itemsss");
      if(props.formType == "userCreateData" || props.formType == "userAccessEdit"){
      if(value == ""){
      if(item.field_related_dropdown != ""){
        let reall = relatedDropdowns
        for (let i in reall){
            delete reall[i].nowValues
        }
        setRelatedDropdowns({...reall})
      }
    }
  }
    })
  };

  // dropdown value selected
  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    setValue(value)
    
    //console.log(haveRelated,"itemsss");
    //console.log(value,"itemsss");
    
    if (value == "None") {
      if (dropdownParent == "country") {
        setState({ ...state, [dropdownParent]: [] });
      } else {
        let newState = state
        delete newState[dropdownParent];
        setState({...newState})
      }

      setDropdownState(dropDownsInitialStates);
    }
    // console.log("state beforedropping tdonw", state)
    else{

    
      let newState = state;
    if(haveRelated) {
      
      delete newState[haveRelated];

      let relatedDropdownsToChange = relatedDropdowns
      props.data.map((item, index) => {
        if (item.value == haveRelated) {
         
          
          if (
            camelize(item.field_related_dropdown) != null &&
            camelize(item.field_related_dropdown).length > 0
          ) {
            
          
              delete newState[camelize(item.field_related_dropdown)];
              delete relatedDropdownsToChange[camelize(item.field_related_dropdown)].nowValues
            
          }
        }
      });

     // setState({...newState});
      const selectedRelatedDropdown = relatedDropdownsToChange[haveRelated];

      selectedRelatedDropdown.nowValues = selectedRelatedDropdown.filter(
        (item) => item.field_title == value
      )[0].field_options;

      setRelatedDropdowns({...relatedDropdownsToChange, [haveRelated] : selectedRelatedDropdown})

    }

    
    setDropdownState({...dropDownsInitialStates});
    setState({ ...newState, [dropdownParent]: value });
    if (props.params == "approval") {
      props.sendFormValues({
        ...newState,
        [dropdownParent]: value,
      });
    }
    if (props.formType == "approval") {
      if (dropdownParent == "1.PleaseSelectTheProcessArea") {
        props.sendDataToApproval({
          subProcess: state["1.PleaseSelectTheSub-ProcessArea"],
          process: value,
        }, null, false);
      } else {
        props.sendDataToApproval({
          process: state["1.PleaseSelectTheProcessArea"],
          subProcess: value,
        }, null, false);
      }
    }
  }
  };


  React.useEffect(() => {
     // console.log(state, "state is")
  }, [state])

  // date selected
  const handleDate = (date, parent) => {
    if (typeof date == "object") {
      var bigDate = date._d;
      let thisDate = bigDate.getDate()
      let thisMonth = bigDate.getMonth()+1
      if (thisMonth.toString().length ==1) {
        thisMonth = "0"+ thisMonth.toString()
      }
      if (thisDate.toString().length ==1) {
        thisDate = "0"+ thisDate.toString()
      }

      let thisYear = bigDate.getFullYear()

      //console.log(thisMonth, "thisMonth")
   
      // var dd = String(bigDate.getDate()).padStart(2, "0");
      // var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
      // var yyyy = bigDate.getFullYear();
      const myDate = thisDate + "-" + thisMonth + "-" + thisYear;
     // console.log(myDate, "myDate")
      
      setState({ ...state, [parent]: myDate });
    } else {
      setState({ ...state, [parent]: date._d });
    }
  };

  // send state to parent
  React.useEffect(() => {
   //console.log("state get form value basic form-----", state);
  //console.log(props.getFormValues, "getFormValues")
    if (props.getFormValues) {
    
      let moveAhead = true;
      //console.log("required Fields", requiredFields);

      for (let i in requiredFields) {
       
        if (
          state[requiredFields[i]] == "" ||
          state[requiredFields[i]] == false ||
          state[requiredFields[i]] === undefined ||
          state[requiredFields[i]] == undefined||
          state[requiredFields[i]] == "undefined"||
          state[requiredFields[i]] == null
        ) {
         // console.log(state[requiredFields[i]], "let's see")
        
          moveAhead = false;
          break;
        }
      }
      if (moveAhead == true) {
       
       // console.log("sendfrom ----" ,state)
       
        props.sendFormValues(state);
        
        setInvalidFlag(false);
      } else {
        setInvalidFlag(true);
      }
      if (props.setGetFormValues) {
        props.setGetFormValues(false);
      }
    }
  }, [props.getFormValues]);

  // empty states after submit
  // React.useEffect(() => {
  //   if (props.emptyFormValues== true){
  //   setState(initialStates);
  //   setDropdownState(dropDownsInitialStates);
  //   }
  // }, [props.emptyFormValues]);

  // React.useEffect(() => {
  //   if (props.formType == "demand" || props.formType == "getBot"|| props.formType == "userAccessEdit" || props.formType=="userCreateData" ||props.formType=="approval") {
  //     if (props.demandEditData != null) {
  //       setState(props.demandEditData);
  //     }
  //   }
  // }, [props.demandEditData]);



  React.useEffect(() => {
   // console.log(state, "stateChange")
  }, [state])

  return props.data.map((item, index) => {
    if (item.field_input_type == "Radio") {
      //console.log("radioo", item);
      return (
        <div className={styles.colFirst}>
          <div className={styles.row}>
            <div
              className={`${styles.formGroup} ${
                item.field_column_size == "Large" ? styles.fullWidth : null
              }`}
              onChange={inputChange}
            >
              <label className={styles.mainLabel}>
                {item.field_label}{" "}
                {item.field_required == "1" ?<sup className={styles.mandatoryField}>*</sup>: null}
                {/* <sup className={styles.mandatoryField}>*</sup> */}
              </label>

              <div className={styles.inputGroupWrapper}>
                {item.field_options.map((radioItem, index) => {
                  let a = item.value;
                  // console.log(state.a, "whpppppp")

                  return (
                    <label className={styles.radioWrapper} key={index}>
                      <span className={styles.subLabel}>{radioItem}</span>
                      <input
                        type="radio"
                        className={styles.radioBox}
                        value={radioItem}
                        name={item.value}
                        // defaultChecked={
                        //   item.value == "targetPitch"
                        //     ? radioItem == "3A"
                        //       ? true
                        //       : false

                        //     : false
                        // }
                        checked={state[item.value] == radioItem ? true : false}
                      />
                      <span className={styles.radioCheckmark}></span>
                    </label>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (item.field_input_type == "Plain Text") {
      return (
        <div className={styles.colFirst}>
          <div className={styles.row}>
            <div
              className={`${styles.inputGroup} ${
                item.field_column_size == "Large" ? styles.fullWidth : null
              }`}
            >
              <label>
                <span>
                  {/* {" "} */}
                  {item.field_form_field_title}
                  {notRequired.includes(item.field_form_field_title)? null:(item.field_required == "1" ? <sup>*</sup> : null)}
                </span>
                {/* error message */}
                {invalidFlag ? (
                  ( !props.notRequired.includes(item.field_form_field_title) && (( state[item.value] == "" ||
                  state[item.value] == false ||
                  state[item.value] === undefined ||
                  state[item.value] == undefined||
                  state[item.value] == "undefined"||
                  state[item.value] == null) &&
                      item.field_required == "1")) ? (
                    <span className={styles.errorMessage}>
                      {item.field_message_ip_error_message}
                    </span>
                  ) : null
              ) : null}
              </label>
              <p
                className={`${styles.input}  ${
                  invalidFlag
                    ? 
                    (!props.notRequired.includes(item.field_form_field_title) && (( state[item.value] == "" ||
                    state[item.value] == false ||
                    state[item.value] === undefined ||
                    state[item.value] == undefined||
                    state[item.value] == "undefined"||
                    state[item.value] == null)) &&
                        item.field_required == "1")
                      ? styles.errorBorder
                      : null
                    : null
                }`}
              >
                <input
                  type="text"
                  placeholder={item.field_title}
                  name={item.value}
                  onChange={inputChange}
                  defaultValue={state[item.value]}
                />
              </p>
            </div>
          </div>
        </div>
      );
    } else if (item.field_input_type == "Large Plain Text") {
      return (
        <div className={styles.colFirst}>
          <div className={styles.row}>
            <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
              <label>
                <span>
                  {" "}
                  {item.field_form_field_title}
                  {item.field_required == "1" ? <sup>*</sup> : null}
                </span>
                {/* error message */}
                 {invalidFlag ? (
                  !props.notRequired.includes(item.field_form_field_title) &&
                  (state[item.value] == "" ||
                    state[item.value] == false ||
                    state[item.value] === undefined ||
                    state[item.value] == undefined ||
                    state[item.value] == "undefined" ||
                    state[item.value] == null) &&
                  item.field_required == "1" ? (
                    <span className={styles.errorMessage}>
                      {item.field_message_ip_error_message}
                    </span>
                  ) : null
                ) : null}
              </label>
                            <p
                className={`${styles.input}  ${
                  invalidFlag
                    ? !props.notRequired.includes(
                        item.field_form_field_title
                      ) &&
                      (state[item.value] == "" ||
                        state[item.value] == false ||
                        state[item.value] === undefined ||
                        state[item.value] == undefined ||
                        state[item.value] == "undefined" ||
                        state[item.value] == null) &&
                      item.field_required == "1"
                      ? styles.errorBorder
                      : null
                    : null
                }`}
              >
                <input
                  type="text"
                  placeholder={item.field_title}
                  name={item.value}
                  onChange={inputChange}
                  defaultValue={state[item.value]}
                />
              </p>
            </div>
          </div>
        </div>
      );
    } else if (
      item.field_input_type == "Dropdown" ||
      item.field_input_type == "Related Dropdown"
    ) {
      return (
        <div
          className={props.type === "form" ? styles.coluser : styles.colFirst}
        >
          <div className={styles.row}>
            <div
              className={
                props.params === "approval"
                  ? `${styles.approvalgroup}`
                  : props.type === "form"
                  ? `${styles.approvalgroup}`
                  : props.type === "user"
                  ? `${styles.userGroup}`
                  : `${styles.inputGroup}`
              }
            >
              <label>
                <span>
                  {item.field_form_field_title}
                  {item.field_required == "1" && props.params != "approval" ? (
                    <sup>*</sup>
                  ) : null}
                </span>
                {/* error message */}
                {props.invalidFlag &&
                (!props.state["dropData"]?.process ||
                  !props.state["dropData"]?.subProcess) ? (
                  <span className={styles.errorMessage}>
                    {item.field_message_ip_error_message}
                  </span>
                ) : null}
              </label>
              <p
                className={`${styles.input} ${
                  invalidFlag
                    ? ( ( state[item.value] == "" ||
                    state[item.value] == false ||
                    state[item.value] === undefined ||
                    state[item.value] == undefined||
                    state[item.value] == "undefined"||
                    state[item.value] == null) &&
                        item.field_required == "1")
                      ? styles.errorBorder
                      : null
                    : null
                }`}
                onClick={() => {
                  handleDropDown(item.value);
                }}
              >
                <span className={styles.left}>
                  {state[item.value] == "" ||
                  state[item.value] == null ||
                  state[item.value] == "undefined"||
                  item.field_label == "Country"
                    ? item.field_input
                    : state[item.value]}
                </span>
                <span className={styles.right}>
                  <Icons name="chevron" className={styles.chevron} />
                </span>
              </p>
              {dropDownState[item.value] == true ? (
                <div className={styles.dropdown}>
                 {/* {console.log(relatedDropdowns,"relatedDropdowns")} */}
                  <DropDown
                    
                    formType={props.formType}
                    dropdownParent={item.value}
                    params={props.params}
                    values={
                      item.field_input_type == "Related Dropdown"
                        ? relatedDropdowns[item.value].nowValues != undefined
                          ? [
                            //  "None",
                           ...relatedDropdowns[item.value].nowValues]
                          : ["No parent Selected"]
                        : [
                          // "None"
                          , ...item.field_options]
                    }
                    getDropdownValue={gotDropDownValue}
                    haveRelated={camelize(item.field_related_dropdown)}
                    closeAllDropdowns={() => {
                      setDropdownState(dropDownsInitialStates);
                    }}
                  />
                </div>
              ) : null}
              {item.field_label == "Country"
                ? state[item.value].map((multipleItem, index) => (
                    <span key={index} className={styles.multipleItems}>
                      {multipleItem}
                    </span>
                  ))
                : null}
            </div>
          </div>
        </div>
      );
    } else if (item.field_input_type == "Date") {
     // console.log(state[item.value], "statevalue");

      return (
        <div className={styles.colFirst}>
          <div className={styles.row}>
            <div className={`${styles.inputGroup} `}>
              <label>
                <span>
                  {" "}
                  {item.field_label}{" "}
                  {item.field_required == "1" ? <sup>*</sup> : null}
                </span>
                {/* error message */}
                {invalidFlag ? (
                  ( ( state[item.value] == "" ||
                  state[item.value] == false ||
                  state[item.value] === undefined ||
                  state[item.value] == undefined||
                  state[item.value] == "undefined"||
                  state[item.value] == null) &&
                      item.field_required == "1") ? (
                    <span className={styles.errorMessage}>
                      Incorrect Format
                    </span>
                  ) : null
                ) : null}
              </label>

              <Datetime
                closeOnSelect={true}
                // initialValue={_.get(state, "dateLogged", [
                //   "2020-11-12",
                // ])}
                value={_get(state, item.value)}
                timeFormat={false}
                dateFormat={"DD-MM-YYYY"}
                className={`${styles.calender}  ${
                  invalidFlag
                    ? ( ( state[item.value] == "" ||
                    state[item.value] == false ||
                    state[item.value] === undefined ||
                    state[item.value] == undefined||
                    state[item.value] == "undefined"||
                    state[item.value] == null) &&
                        item.field_required == "1")
                      ? styles.errorBorder
                      : null
                    : null
                }`}
                inputProps={inputprops}
                onChange={(date) => handleDate(date, item.value)}
                
              />
            </div>
          </div>
        </div>
      );
    }
  });
}

export default index;

